<div class="coupon-container">
    <div class="subcontainer" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="label">優惠碼</div>
        <div class="coupon-input"><app-input-with-button (onClick)="applyCouponCode($event)" [lock]="lock" [disabled]="cart && cart.isCouponActive" [(value)]="cart.couponCode" type="text" placeholder=""></app-input-with-button></div>
    </div>
    <div class="error" *ngIf="cart && cart.isCouponInvalid">優惠碼不正確</div>
    <div class="rule" *ngFor="let rule of rules">{{rule.ruleEavs | getValueByAttribute:'label':'value'}}</div>
    <div class="rule" *ngIf="cart && cart.remark">{{cart.remark}}</div>
</div>